import { Button } from "@/components/ui/Button";
import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/Tooltip";
import { cn } from "@/lib/utils";
import React from "react";

interface ToggleButtonWithIconProps {
  icon: React.ComponentType<React.SVGProps<SVGSVGElement>>;
  isActive: boolean;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  tooltipTextActive?: string;
  tooltipTextInactive?: string;
  activeClassName?: string;
  inactiveClassName?: string;
  className?: string;
  iconClassName?: string;
}

export const RoundButtonWithToggleIcon: React.FC<ToggleButtonWithIconProps> = ({
  icon: Icon,
  isActive,
  onClick,
  tooltipTextActive = "",
  tooltipTextInactive = "",
  activeClassName = "text-yellow-500",
  inactiveClassName = "text-foreground",
  className = "",
  iconClassName = "",
}) => {
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.preventDefault();
    event.stopPropagation();
    onClick(event);
  };

  return (
    <div className="relative group">
      <TooltipProvider delayDuration={0}>
        <Tooltip>
          <TooltipTrigger asChild>
            <Button
              type="button"
              variant="outline"
              size="icon"
              onClick={handleClick}
              className={cn(
                "rounded-full border-transparent p-2 hover:border-input",
                isActive ? activeClassName : inactiveClassName,
                className,
              )}
            >
              <Icon
                className={cn(
                  "size-5 transition-transform group-hover:scale-110",
                  iconClassName,
                )}
              />
            </Button>
          </TooltipTrigger>
          {tooltipTextActive && tooltipTextInactive && (
            <TooltipContent side="top" sideOffset={15}>
              {isActive ? tooltipTextActive : tooltipTextInactive}
            </TooltipContent>
          )}
        </Tooltip>
      </TooltipProvider>
    </div>
  );
};
